import {handleActions} from 'redux-actions';

const initialState = {

};

const immigrantReducers = handleActions(
    {},
    initialState
);

export default immigrantReducers;
